<template>
  <div class="performances">
    <div class="buttons c:row-start-center">
      <div
        v-for="item in properties"
        :key="item.key"
        class="button"
        :class="{ active: item.key === activeProperty }"
        @click="onChangeProperty(item)"
      >
        {{ item.label }}
      </div>
    </div>
    <div class="table">
      <div class="table-header">
        <div class="table-row c:row-between-center">
          <div class="table-cell c:row-center head-cell"></div>
          <div
            v-for="item in categories"
            :key="item.key"
            class="table-cell c:row-center head-cell"
            :class="{ active: activeCategory == item.key }"
            @click="onChangeDate(item.key)"
          >
            {{ item.label }}
          </div>
        </div>
      </div>
      <div class="table-body">
        <div
          class="table-row c:row-between-center"
          v-for="(item, index) in listData"
          :key="index"
        >
          <div class="table-cell head-cell c:row-start-center">
            <div class="label">{{ item.keyWord }}</div>
          </div>
          <div
            v-for="(cat, idx) in categories"
            :key="idx"
            class="table-cell c:row-center"
            :class="{ active: activeCategory === cat.key }"
          >
            {{ activeProperty == "salesAmount" ? "¥" : "" }}{{ item[cat.key] }}
          </div>
        </div>
      </div>
    </div>
    <div class="chart">
      <CChart :options="chartOptions" :height="300" />
    </div>
    <CBottomPad is-tab-page />
  </div>
</template>
<script>
import { getRMStorePerformance, getSMStoreReportByCa } from "@/api";
import { USER_ROLES } from "@/consts";
import CChart from "../common/CChart.vue";
import CBottomPad from "../common/CBottomPad.vue";
export default {
  components: { CChart, CBottomPad },
  props: {
    role: String,
  },
  data() {
    return {
      activeProperty: "salesAmount",
      activeCategory: "todayValue",
      properties: [
        { label: "销售额", key: "salesAmount" },
        { label: "销售量", key: "salesCount" },
        { label: "订单量", key: "orderCount" },
      ],
      categories: [
        {
          label: "今日",
          key: "todayValue",
        },
        {
          label: "昨日",
          key: "yesterdayValue",
        },
        {
          label: "本周",
          key: "weekValue",
        },
        {
          label: "本月",
          key: "monthValue",
        },
      ],
      dataPool: [],
      listData: [],
      chartOptions: null,
    };
  },
  watch: {
    role: {
      handler(role) {
        if (role) {
          if (role === USER_ROLES.STORE_MANAGER) {
            const storeId = this.$store.getters.currentStore?.storeId;
            if (storeId) {
              this.api = getSMStoreReportByCa.bind(null, storeId);
            } else return;
          } else {
            this.api = getRMStorePerformance;
          }
          this.getData();
        }
      },
      immediate: true,
    },
  },
  methods: {
    async getData() {
      try {
        const res = await this.api();
        console.log("res", res);
        this.dataPool = res;
        this.formatListData();
        this.farmatChartOptions();
      } catch (error) {
        console.log("error", error);
      }
    },
    formatListData() {
      this.listData = this.dataPool[this.activeProperty] || [];
    },
    farmatChartOptions() {
      // 绘制图表
      this.chartOptions = {
        series: [
          {
            type: "pie",
            radius: "50%",
            center: ["50%", "50%"],
            data:
              this.dataPool[this.activeProperty]?.map((item) => ({
                name: item.keyWord,
                value: item[this.activeCategory],
              })) || [],
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  position: "top",
                  formatter: function (val) {
                    if (val.name.length > 8) {
                      val.name = val.name.slice(0, 8) + "...";
                    }
                    return [val.name, val.percent + "%"].join("\n");
                  },
                  textStyle: {
                    fontSize: 12,
                  },
                  rich: {
                    b: {
                      color: "#333",
                    },
                    c: {
                      color: "#9E9E9E",
                    },
                    d: {
                      color: "#9E9E9E",
                    },
                  },
                },
                labelLine: {
                  lineStyle: {
                    color: "#CCCCCC", // 改变标示线的颜色
                  },
                },
              },
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)",
                },
              },
            },
          },
        ],
      };
    },
    onChangeDate(value) {
      this.activeCategory = value;
      this.farmatChartOptions();
    },
    onChangeProperty(item) {
      this.activeProperty = item.key;
      this.formatListData();
      this.farmatChartOptions();
    },
  },
};
</script>
<style lang="less" scoped>
.performances {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding-top: 1/20rem;
  border-top: solid 1px #f2f2f2;

  overflow-x: hidden;
  overflow-y: auto;

  .buttons {
    gap: 15/20rem;

    box-sizing: border-box;
    width: 100%;
    height: 58/20rem;
    padding: 18/20rem 14/20rem 17/20rem;
    border-bottom: 1/20rem solid #f1f1f1;
    background: #fff;

    .button {
      box-sizing: border-box;
      height: 22/20rem;
      padding: 0 10/20rem;
      border: 1/20rem solid #333333;

      line-height: 20/20rem;
      font-weight: 500;
      font-size: 12/20rem;
      letter-spacing: 0;

      opacity: 0.3;

      &.active {
        opacity: 1;
      }
    }
  }

  .table {
    width: 100%;
    background: #fff;
    &-header,
    &-body {
      padding: 0 14/20rem;
    }

    &-row {
      .table-cell {
        height: 45/20rem;
      }
    }

    &-cell {
      flex: 3;
      box-sizing: border-box;
      padding: 0 5/20rem;
      line-height: 17/20rem;
      font-weight: 400;
      font-size: 12/20rem;
      letter-spacing: 0;
      color: #333;
      text-align: center;

      overflow: hidden;
      text-overflow: ellipsis;
      word-break: keep-all;
      white-space: nowrap;

      &:first-child {
        flex: 2;
      }
      &.head-cell {
        font-weight: 500;
      }
      &.active {
        background-color: #f4f4f4;
      }
    }

    &-header {
      border-bottom: 1/20rem solid #f1f1f1;
      .table-row {
        .table-cell {
          height: 38/20rem;
        }
      }
    }
    &-body {
      .table-row {
        &:last-child {
          .table-cell {
            height: 55/20rem;
            padding-bottom: 10/20rem;
          }
        }
      }
      .table-cell.head-cell {
        .label {
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          word-break: keep-all;
          white-space: nowrap;
          text-align: left;
        }
      }
    }
  }

  .chart {
    border-top: 1/20rem solid #f1f1f1;
    background: #fff;
  }
}
</style>
